import type { FC } from 'react';
import { useContext } from 'react';

import { isUnicodeEmoji } from '@/mastodon/features/emoji/utils';

import { Emoji } from './emoji';
import { AnimateEmojiContext } from './emoji/context';

interface ReactionEmojiProps {
  name: string;
  url?: string;
  staticUrl?: string;
}

export const ReactionEmoji: FC<ReactionEmojiProps> = ({
  name,
  url,
  staticUrl,
}) => {
  const animate = useContext(AnimateEmojiContext);
  const unicode = isUnicodeEmoji(name);
  const src = animate ? (url ?? staticUrl) : (staticUrl ?? url);

  if (!unicode && src) {
    const shortcode = `:${name}:`;

    return (
      <img
        src={src}
        alt={shortcode}
        title={shortcode}
        className='emojione custom-emoji'
        loading='lazy'
      />
    );
  }

  return <Emoji code={unicode ? name : `:${name}:`} />;
};
